export default __webpack_public_path__ + "static/media/PRA_Walk_Loop-v3.64b8eee1.wav";